import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bf-filters" }
const _hoisted_2 = { class: "bf-period" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "bf-custom-range__field" }
const _hoisted_5 = { class: "bf-custom-range__field" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextInput = _resolveComponent("TextInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.periods, (period) => {
        return (_openBlock(), _createElementBlock("span", {
          key: period.value,
          class: _normalizeClass(["bf-period__pill", { 'bf-period__pill--active': _ctx.activePeriod === period.value }]),
          onClick: ($event: any) => (_ctx.selectPeriod(period.value))
        }, _toDisplayString(period.label), 11, _hoisted_3))
      }), 128))
    ]),
    (_ctx.activePeriod === 'custom')
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          class: "bf-custom-range",
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.handleFilter()), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_TextInput, {
              type: 'datetime-local',
              label: 'Data Inicial',
              modelValue: _ctx.initial_datetime,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.initial_datetime) = $event)),
              required: false,
              "onUpdate:value": _cache[1] || (_cache[1] = (initial_datetime) => _ctx.updateInitDate(initial_datetime))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_TextInput, {
              type: 'datetime-local',
              label: 'Data Final',
              required: false,
              modelValue: _ctx.final_datetime,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.final_datetime) = $event)),
              "onUpdate:value": _cache[3] || (_cache[3] = (final_datetime) => _ctx.updateFinishDate(final_datetime))
            }, null, 8, ["modelValue"])
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("button", {
            type: "submit",
            class: "bf-btn bf-custom-range__apply"
          }, "Aplicar", -1))
        ], 32))
      : _createCommentVNode("", true)
  ]))
}